import React from 'react';
import styled from 'styled-components';
import Badge from '@components/shared/Badge';
import { BadgeSizeType } from '@contracts';
import useTranslate from '@hooks/useTranslate';

interface Props {
  isNew?: boolean;
}

export default function NavBarNewBadge({ isNew }: Props) {
  const { t } = useTranslate();

  if (!isNew) {
    return null;
  }

  return (
    <Wrapper>
      <Badge text={t('components.new')} sizeTypes={[BadgeSizeType.ExtraSmall]} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
